import * as React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, hint, style, ...rest }, ref) => (
    <div style={{ marginBottom: 18 }}>
      {label && (
        <label
          style={{
            display: "block",
            fontSize: 12,
            fontWeight: 600,
            color: "var(--n600)",
            marginBottom: 6,
          }}
        >
          {label}
        </label>
      )}
      <input
        ref={ref}
        style={{
          width: "100%",
          height: 48,
          border: "1.5px solid var(--n100)",
          borderRadius: 10,
          padding: "0 14px",
          fontSize: 14,
          fontFamily: "inherit",
          color: "var(--ink)",
          outline: "none",
          background: "var(--white)",
          ...style,
        }}
        {...rest}
      />
      {hint && (
        <div style={{ fontSize: 11, color: "var(--n400)", marginTop: 4 }}>{hint}</div>
      )}
    </div>
  ),
);
Input.displayName = "Input";
